import React from 'react'
import { TimeRangeInput } from './TimeRangeInput'

const DEFAULT_OPEN  = '09:00'
const DEFAULT_CLOSE = '17:00'

function CustomDateRow({ entry, index, onChange, onRemove }) {
  const closed = !!entry.closed

  function handleClosedToggle(checked) {
    onChange(
      index,
      checked
        ? { ...entry, closed: true,  opens_at: null,         closes_at: null }
        : { ...entry, closed: false, opens_at: DEFAULT_OPEN, closes_at: DEFAULT_CLOSE }
    )
  }

  return (
    <tr>
      <td style={{ verticalAlign: 'middle' }}>
        <input
          type="date"
          className="form-control"
          style={{ width: 150 }}
          value={entry.date || ''}
          onChange={(e) => onChange(index, { ...entry, date: e.target.value })}
        />
      </td>
      <td style={{ verticalAlign: 'middle' }}>
        <input
          type="text"
          className="form-control"
          style={{ width: 200 }}
          placeholder="Label (optional)"
          value={entry.name || ''}
          onChange={(e) => onChange(index, { ...entry, name: e.target.value })}
        />
      </td>
      <td style={{ verticalAlign: 'middle' }}>
        <input type="checkbox" checked={closed} onChange={(e) => handleClosedToggle(e.target.checked)} />
      </td>
      <td style={{ verticalAlign: 'middle' }}>
        {closed ? (
          <span className="dome-p2 dome-color-med-grey">closed all day</span>
        ) : (
          <TimeRangeInput
            open={entry.opens_at || ''}
            close={entry.closes_at || ''}
            onChange={({ open, close }) => onChange(index, { ...entry, opens_at: open, closes_at: close })}
          />
        )}
      </td>
      <td style={{ verticalAlign: 'middle' }}>
        <button type="button" className="btn btn-xs btn-danger" onClick={() => onRemove(index)}>
          <i className="fa fa-trash" aria-hidden="true" />
        </button>
      </td>
    </tr>
  )
}

export function CustomDatesEditor({ customDates, onChange, onAdd, onRemove, onSave, error, dirty = true }) {
  return (
    <div>
      <h4 className="dome-color-darkest-grey" style={{ marginBottom: 12 }}>
        Specific Date Overrides
      </h4>
      <p className="dome-p2 dome-color-med-grey" style={{ marginBottom: 16 }}>
        Add specific one-time calendar dates (non-recurring) with custom hours or full-day closure. Custom dates cannot
        duplicate an already-enabled holiday.
      </p>

      {customDates.length > 0 && (
        <table className="table table-condensed" style={{ tableLayout: 'auto' }}>
          <thead>
            <tr>
              <th>Date</th>
              <th>Label</th>
              <th style={{ width: 80 }}>Closed</th>
              <th style={{ width: 280 }}>Hours</th>
              <th style={{ width: 40 }} />
            </tr>
          </thead>
          <tbody>
            {customDates.map((entry, i) => (
              <CustomDateRow key={i} entry={entry} index={i} onChange={onChange} onRemove={onRemove} />
            ))}
          </tbody>
        </table>
      )}

      <div className="dome-d-flex dome-align-center dome-gap6" style={{ marginTop: 8 }}>
        <button type="button" className="btn btn-default btn-sm" onClick={onAdd}>
          <i className="fa fa-plus" aria-hidden="true" /> Add date
        </button>
        <button
          type="button"
          className={`dome-btn dome-btn-base ${dirty ? 'dome-btn-green-stroke' : 'dome-btn-disabled'}`}
          onClick={onSave}
          disabled={!dirty}
        >
          Save Custom Dates
        </button>
        {error && <span className="text-danger dome-p3">{error}</span>}
      </div>
    </div>
  )
}
